










import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { TimeFormatKinds, ITimeStyle } from "../../../../../documaker/domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
  }
})

export default class TimeStyleEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: ITimeStyle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITimeStyle) => T, defaultValue: T) => T;
  
  get formatKind(): TimeFormatKinds {
    return this.readPropertyOrDefault(s => s.formatKind, TimeFormatKinds.String12hJa);
  }

  set formatKind(value: TimeFormatKinds) {
    this.writePropertyWhenValid(s => s.formatKind = value);
  }

  formatKindOptions: StandardOption<number>[] = [
    new StandardOption<number>("時分(午前・午後)", TimeFormatKinds.String12hJa),
    new StandardOption<number>("時分(AM・PM)", TimeFormatKinds.String12hEn),
    new StandardOption<number>("時分(12時間)", TimeFormatKinds.String12h),
    new StandardOption<number>("時分(24時間)", TimeFormatKinds.String24h),
    new StandardOption<number>("時:分(AM・PM)", TimeFormatKinds.Colon12hEn),
    new StandardOption<number>("時:分(12時間)", TimeFormatKinds.Colon12h),
    new StandardOption<number>("時:分(24時間)", TimeFormatKinds.Colon24h),
  ];
}
